/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Intakeeventsmany2Inputs */

const en_intakeeventsmany2 = /** @type {(inputs: Intakeeventsmany2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} events`)
};

const pt_intakeeventsmany2 = /** @type {(inputs: Intakeeventsmany2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} eventos`)
};

/**
* | output |
* | --- |
* | "{count} events" |
*
* @param {Intakeeventsmany2Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const intakeeventsmany2 = /** @type {((inputs: Intakeeventsmany2Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Intakeeventsmany2Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_intakeeventsmany2(inputs)
	return pt_intakeeventsmany2(inputs)
});
export { intakeeventsmany2 as "intakeEventsMany" }